import { render, staticRenderFns } from "./PAProductList.vue?vue&type=template&id=1f0594e8&"
import script from "./PAProductList.vue?vue&type=script&lang=js&"
export * from "./PAProductList.vue?vue&type=script&lang=js&"
import style0 from "./PAProductList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PAProductList.vue"
export default component.exports